package kz.dentalcrm.app.screens.quick_replies.add.mvi

import kz.dentalcrm.app.core.base.ViewState

data class AddQuickReplyViewState(
    val screenState: ScreenState = ScreenState.Idle
) : ViewState {

    sealed interface ScreenState {
        data object Idle : ScreenState
        data object Adding : ScreenState
        data object Added : ScreenState
        data class Error(val error: String) : ScreenState
    }
}
